import { Route, Routes } from 'react-router-dom';

import { ApiKey } from './pages/apiKey/apiKey.lazy';
import { AuditLogRouting } from './auditLog.lazy';
import { DisableTwoFactor } from './pages/disableTwoFactor/disableTwoFactor.lazy';
import { EnableAuthenticator } from './pages/enableAuthenticator/enableAuthenticator.lazy';
import { GenerateRecoveryCodes } from './pages/generateRecoveryCodes/generateRecoveryCodes.lazy';
import { ResetAuthenticator } from './pages/resetAuthenticator/resetAuthenticator.lazy';
import { TwoFactorAuthentication } from './pages/twoFactorAuthentication/twoFactorAuthentication.lazy';

export const SecurityRouting = () => {
  return (
    <Routes>
      <Route path="apikey" element={<ApiKey />} />
      <Route path="twoFactorAuthentication" element={<TwoFactorAuthentication />} />
      <Route path="enableAuthenticator" element={<EnableAuthenticator />} />
      <Route path="resetAuthenticator" element={<ResetAuthenticator />} />
      <Route path="disable2fa" element={<DisableTwoFactor />} />
      <Route path="generateRecoveryCodes" element={<GenerateRecoveryCodes />} />
      <Route path="logs/*" element={<AuditLogRouting />} />
    </Routes>
  );
};
